<template>
    <div class="container">
        <div class="google-map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10498.949254322206!2d2.368763203671804!3d48.863219347263104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9030ae0973064506!2sKate%20Mack!5e0!3m2!1sen!2sfr!4v1575332140982!5m2!1sen!2sfr" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
        </div>
        <div class="right">
            <div class="address">
                <span>KATE MACK</span>
                <span>15 Rue Oberkampf</span>
                <span>75011 Paris, France</span>
                <span>kate@kate-mack.com</span>
            </div>
            <div class="form">
                <form action="/kate-contact.php" method="post">
                    <div class="input">
                        <span>Nom : </span>
                        <input type="text" name="nom" id="nom" required disabled>
                    </div>
                    <div class="input">
                        <span>Email : </span>
                        <input type="text" name="email" id="email" required disabled>
                    </div>
                    <div class="input">
                        <span>Téléphone : </span>
                        <input type="text" name="telephone" id="telephone" disabled>
                    </div>
                    <div class="input">
                        <span>Message : </span>
                        <textarea name="message" id="message" cols="30" rows="10" required disabled></textarea>
                    </div>
                    <input type="submit" value="Envoyer" disabled="disabled">
                </form>
            </div>

        </div>
        <div id="adn">                                                                     
            <span>Kate Mack . Wearable Art Dealer. Fashion Made Organically. </span>
            <span>Made in Paris. Artisan Designer. Slow Fashion. Bespoke. Local Designer. Small business </span>
            <span>In a world full of possibilities, thanks for buying from us...</span>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Contact',
  components: {
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: `Kate Mack Contact`,
    // all titles will be injected into this template
    titleTemplate: null,
    description: 'Kate Mack - Contact',
    meta: [
      { charset: 'utf-8' },
      { 
        name: 'keywords',
        content: 'kate-mack, Kate, Mack, kate mack, Wearable Art Dealer, art, fashion, Local Designer, Small business, Designer, Artisan, Artisan Designer'
      },
      {
        property: 'og:title',
        content: 'Kate Mack',
        // following template options are identical
        // template: '%s - My page',
        template: chunk => `${chunk} - Contact`,
        vmid: 'og:title'
      },
      {
        property: 'og:url',
        content: `https://kate-mack.com/contact`,
        vmid: 'og:url'
      }
    ]
  },
}
</script>

<style lang="scss" scoped>

div.container {
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    div.google-map {
        max-width: 100%;
        margin: 1rem;
        iframe {
            max-width: 100%;
        }
    }
    div.right {
        padding: 0.8rem 2rem;
        div.address {
            display: flex;
            flex-direction: column;
            span {
                font-size: 110%;
                padding: 0.1rem;
                &:last-child {
                    padding: 0.6rem;
                }
            }
        }
        form {
            width: 100%;
            display: flex;
            flex-direction: column;
            div.input {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-direction: column;
                width: 100%;
                span {
                    flex: 1;
                    padding-right: 0.5rem;
                    justify-self: flex-start;
                    text-align: right;
                }
                input, textarea {
                    width: 300px;
                }
                textarea {
                    resize: none;
                }
                input, textarea {
                    font-size: 100%;
                    border: solid 1px white;
                    border-radius: 5px;
                    background-color: white;
                    color: black;
                    padding: 0.5em;
                    resize: none;
                    overflow: hidden;
                    height: auto;
                    margin: 0.5em 0;
                }
            }
            input[type=submit] {
                border: solid 0.1rem white;
                border-radius: 5px;
                margin: 0.5rem;
                padding: 0.4rem;
                &:hover {
                    cursor: pointer;
                    color: black;
                    background-color: white;
                    border-color: black;
                }
            }
        }
    }
    div#adn {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        padding: 1rem 0.5rem;
    }
}

@media screen and (min-width: 600px) {
div.container {
    div.right {
        form {
            div.input {
                flex-direction: row;
            }
        }
    }
}


}
</style>